import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import DescriptionIcon from "@mui/icons-material/Description";
import Tooltip from "@mui/material/Tooltip";
import SaveIcon from "@mui/icons-material/Save";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function Applicants() {
  // Variable Declarations
  const [status, setStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  const [applicants, setApplicants] = useState([]);

  const [editedRowId, setEditedRowId] = useState(null);

  const handleEditStatusClick = (rowId, currentStatus) => {
    setEditedRowId(rowId);
    setNewStatus(currentStatus);
  };

  const handleSaveStatusClick = (id) => {
    addStatus(id);
    setEditedRowId(null);
  };

  const [formErrors, setFormErrors] = useState({
    status,
  });

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const [maxWidth, setMaxWidth] = useState("xl");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Session Storage handling
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "ID", accessor: "id", align: "center" },
    { Header: "First Name", accessor: "f_name", align: "center" },
    { Header: "Last Name", accessor: "l_name", align: "center" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Phone", accessor: "phone", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
  ];

  const rows =
    applicants.length > 0
      ? applicants.map((app, index) => ({
          serial: index + 1,
          id: app.id,
          f_name: app.applicant_first_name,
          l_name: app.applicant_last_name,
          email: app.applicant_email,
          phone: app.applicant_phone,
          status: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {editedRowId === app.id ? (
                  <>
                    <Dropdown
                      selection
                      value={newStatus}
                      onChange={(e, { value }) => setNewStatus(value)}
                      options={[
                        { key: "Emailed", text: "Emailed", value: "Emailed" },
                        { key: "Called", text: "Called", value: "Called" },
                        {
                          key: "Not Answered",
                          text: "Not Answered",
                          value: "Not Answered",
                        },
                      ]}
                      optionLabel="status"
                      optionValue="id"
                    />
                    <Tooltip title="Save Status">
                      <IconButton
                        aria-label="Save Status"
                        color="primary"
                        onClick={() => handleSaveStatusClick(app.id)}
                      >
                        <SaveIcon style={{ color: "green" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <span>{app.status}</span>
                    <Tooltip title="Edit Status">
                      <IconButton
                        aria-label="Edit Status"
                        color="primary"
                        onClick={() =>
                          handleEditStatusClick(app.id, app.status)
                        }
                      >
                        <EditIcon style={{ color: "blue" }} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          ),
        }))
      : [
          {
            serial: null,
            id: null,
            f_name: null,
            l_name: null,
            email: null,
            phone: null,
            status: null,
          },
        ];

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getApplicants();
    } else {
      let filteredApplicants = applicants.filter((app) => {
        const idMatch = app.id && app.id.toString().includes(searchTerm);
        const applicantFirstNameMatch =
          app.applicant_first_name &&
          app.applicant_first_name.toLowerCase().includes(searchTerm);
        const applicantLastNameMatch =
          app.applicant_last_name &&
          app.applicant_last_name.toLowerCase().includes(searchTerm);
        const applicantEmailMatch =
          app.applicant_email &&
          app.applicant_email.toLowerCase().includes(searchTerm);
        const applicantPhoneMatch =
          app.applicant_phone &&
          app.applicant_phone.toLowerCase().includes(searchTerm);
        const statusMatch =
          app.status && app.status.toLowerCase().includes(searchTerm);

        return (
          idMatch ||
          applicantFirstNameMatch ||
          applicantLastNameMatch ||
          applicantEmailMatch ||
          applicantPhoneMatch ||
          statusMatch
        );
      });

      setApplicants(filteredApplicants);
    }
  };

  const handleExportCSV = () => {
    const data = [
      columns.map((col) => col.Header),
      ...rows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Applicants.csv";

    link.click();
  };

  // GET Api calls
  const getApplicants = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/applicant/get_applicants`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setApplicants(data.applicants);
      })
      .catch((error) => console.log(error));
  };

  // Add API call
  const addStatus = (id) => {
    let data = { status: newStatus };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(
      `${BASE_URL}/applicant/change_applicant_status/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getApplicants();
        toast.success("Status Changed Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setStatus("");
        setNewStatus("");
      });
  };

  useEffect(() => {
    getApplicants();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>
                  <Button
                    variant="outlined"
                    endIcon={<DescriptionIcon className="add-icon" />}
                    onClick={handleExportCSV}
                    className="add-full-button"
                  >
                    Export CSV
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {applicants && applicants.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Applicants;
